<template>
  <div class="wrapper paddBottom">
    <div class="header">
      <el-carousel
        :autoplay="true"
        :interval="10000"
        :loop="true"
        style="width: 100%;"
        :style="{height:c + 'px'}"
        v-if="urlList !=''&&urlList !=null"
      >
        <el-carousel-item
          v-for="item in urlList"
          :key="item.id"
          style="width: 100%;"
          :style="{height:c + 'px'}"
        >
          <img :src="item.url" alt style="width: 100%;" :style="{height:c + 'px'}" />
          <div class="position">
            <div class="content" :style="{top:b / 13.3 + 'px',left:b / 11 + 'px'}">
              <div class="nav_title animated tada">{{item.title}}</div>
              <div class="desc">{{item.subTitle}}</div>
              <div
                class="button"
                v-if="false"
                :style="{marginTop:b / 17 + 'px'}"
                @click="goLink(item)"
              >REQUEST ACCESS</div>
            </div>
            <img
              style="cursor: pointer;"
              src="@/assets/logo2.png"
              alt
              @click="goSearch(1)"
              class="logoPic"
              :style="{width: b / 5 + 'px',height: c / 7 + 'px',right:40 + 'px',top:(c - (c / 7) - 30) + 'px'}"
            />
            <img
              style="cursor: pointer;"
              src="@/assets/logo1.png"
              alt
              @click="goSearch(2)"
              class="logoPic"
              :style="{width: b / 5 + 'px',height: c / 7 + 'px',right:(b / 5) + 80 + 'px',top:(c - (c / 7) - 30) + 'px'}"
            />
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="position">
        <IndexHeader ref="indexHeader" subName="Events" :imgBg="showImgBg" />
      </div>
    </div>
    <div class="boxContent">
      <!-- <div class="diqiu1" :style="{width:b / 2.5 + 'px',height:b / 3.7 + 'px',top:b / 55 + 'px',right:b / 21.8 + 'px '}">
				<img src="@/assets/slices_slices/4.svg" alt="" :style="{width:b / 2.5 + 'px',height:b / 3.7 + 'px'}" />
			</div>
			<div class="feixingqi">
				<img src="@/assets/slices_slices/7.svg" alt="" />
			</div>
			<div class="diqiu2" :style="{width:b / 4.6 + 'px',height:b / 3.8 + 'px',bottom:-(b / 16) + 'px',right:b / 13 + 'px '}">
				<img src="@/assets/slices_slices/8.svg" alt="" :style="{width:b / 4.6 + 'px',height:b / 3.8 + 'px'}" />
      </div>-->
      <!-- <div class="h1Title" :style="{fontSize:b / 35.6 + 'px',width:b / 2.5 + 'px'}">
				{{ title }}
			</div>
			<div class="h1Desc" :style="{fontSize:b / 137 + 'px',width:b / 3.4 + 'px'}">
				{{ description }}
      </div>-->
      <!-- height:b / 4.45 + 'px', -->
      <div class="twoCard" :style="{width:b / 1.6 + 'px',padding:(b / 48 + 'px', b / 71 + 'px')}">
        <div class="cardTitle" :style="{fontSize:b / 54.8 + 'px'}">Latest Events</div>
        <div style="display: flex;">
          <div class="cont">
            <!-- <i class="el-icon-more searchMessage"></i> -->
            <div class="text_list" :style="{marginTop:b / 64 + 'px'}">
              <!-- <el-collapse v-model="activeName" accordion>
								<div class="li" v-for="(item, index) in text_list" :key="index" :title="item.title">
									<span></span>
									<el-collapse-item :name="item.id" class="fqTitle" :style="{width:b / 3 + 'px'}">
										<templete slot="title">
											<div class="overHide">
												{{item.title}}
											</div>
										</templete>
										<div @click="itemid(item)" style="cursor: pointer">
											<p style="margin: 0">trigger Time:{{ item.triggerTime }}</p>
											<p style="margin: 0">
												Ra/Dec(J2000): {{ item.ra }} {{ item.declination }}
											</p>
										</div>
									</el-collapse-item>
								</div>
              </el-collapse>-->
              <div class="anNi">
                <div style="display: flex;">
                 
                  <div
                    :style="{width:b / 20.4 + 'px',height: b / 53 + 'px',lineHeight:b / 53 + 'px', fontSize:b / 128 + 'px'}"
                    :class="Lastests == 'GRB' ? 'btnMini isActive' : 'btnMini'"
                    @click="
									  Lastests = 'GRB';
									  getLastests('GRB');
									"
                  >GRB</div>
                  <div
                      :style="{width:b / 20.4 + 'px',height: b / 53 + 'px',lineHeight:b / 53 + 'px', fontSize:b / 128 + 'px'}"
                      :class="Lastests == 'GW' ? 'btnMini isActive' : 'btnMini'"
                      @click="
									  Lastests = 'GW';
									  getLastests('GW');
									"
                  >GW</div>
                  
                  <div
                    :style="{width:b / 20.4 + 'px',height: b / 53 + 'px',lineHeight:b / 53 + 'px', fontSize:b / 128 + 'px'}"
                    :class="Lastests == 'HEN' ? 'btnMini isActive' : 'btnMini'"
                    @click="
									  Lastests = 'IceCube';
									  getLastests('HEN');
									"
                  >HEN</div>
                  <div
                    :style="{width:b / 20.4 + 'px',height: b / 53 + 'px',lineHeight:b / 53 + 'px', fontSize:b / 128 + 'px'}"
                    :class="Lastests == 'SGR' ? 'btnMini isActive' : 'btnMini'"
                    @click="
									  Lastests = 'SGR';
									  getLastests('SGR');
									"
                  >SGR</div>
                </div>
                <div
                      :style="{width:b / 20.4 + 'px',height: b / 53 + 'px',lineHeight:b / 53 + 'px', fontSize:b / 128 + 'px'}"
                      :class="Lastests == 'ALL' ? 'btnMini isActive' : 'btnMini'"
                      @click="
									  Lastests = 'ALL';
									  getLastests('ALL');
									"
                  >ALL</div>
                <div
                  :style="{height: b / 53 + 'px',lineHeight:b / 53 + 'px', fontSize:b / 128 + 'px'}"
                  :class="Lastests == 'more' ? ' ' : ''"
                  @click="
										  Lastests = 'more';
										  getLastestsTwo('moreEvent');
										"
                  style="display: flex;align-items: center;"
                >
                  <div
                    style="display: inline-block;font-size: 18px;font-weight: 700;color: #168ec7;cursor: pointer;"
                  >
                    more
                    <sup style="font-size: 10px;">+</sup>
                  </div>
                  <!-- <div style="font-weight: 700;color: #168ec7;">+</div> -->
                </div>
              </div>
              <div
                :class="item.show?'li activea':'li'"
                v-for="(item, index) in text_list"
                :key="index"
                :title="item.title"
              >
                <div>
                  <div
                    :style="{padding:b / 128 + 'px',marginLeft:b / 55 + 'px',paddingLeft:0,paddingRight:0}"
                    style="display: flex;align-items: center;cursor: pointer;padding-right: 0!important;"
                    @click="showDetail(item)"
                  >
                    <span></span>
                    <div
                      :class="item.show?'overHide actives':'overHide'"
                      :style="{fontSize:b / 91 + 'px'}"
                      style="color: #898989;font-weight: 550;"
                      @click="goDetail(item,)"
                    >
                      <div class="titleStyle">{{item.title}}</div>
                      <div style="font-size: 13px;color: #999999;">{{item.triggerTime}}</div>
                    </div>
                  </div>
                  <!-- <transition name="fade"> -->
                  <div
                    @click="itemid(item)"
                    :style="{fontSize:b / 137 + 'px',marginLeft:b / 55 + 'px',paddingBottom:b / 128 + 'px'}"
                    style="cursor: pointer;text-align: left;color: #898989;"
                    v-if="item.show"
                  >
                    <p style="margin: 0">Trigger Time: {{ item.triggerTime }} UTC</p>
                    <p style="margin: 0">Location (J2000): {{ item.ra }} {{ item.declination }}</p>
                  </div>
                  <!-- </transition> -->
                </div>
              </div>
            </div>
          </div>
          <div style="width: 30px;"></div>
          <div class="rightBg" :style="{height: b / 5 + 'px',marginTop:b / 64 + 'px'}">
            <!-- <img src="@/assets/slices_slices/4.svg" alt="" style="position: absolute;left: 0;top: 0;"> -->
            <div
              id="aladin-lite-div"
              style="position: absolute;left: 0;right: 0;top: 0;bottom: 0;margin: auto;width: 86%;height: 86%;"
            ></div>
          </div>
        </div>
      </div>
      <div class="threeCard" :style="{width:b / 1.6 + 'px',padding:(b / 48 + 'px', b / 71 + 'px')}">
        <div
          class="cardTitle"
          style="white-space: nowrap"
          :style="{fontSize:b / 54.8 + 'px'}"
        >Hot Events</div>
        <div class="top">
          <!-- <div class="cardTitle" style="white-space: nowrap;opacity: 0;" :style="{fontSize:b / 54.8 + 'px'}">The Hot Events</div> -->
          <div class="anNi">
            <div style="display: flex;">
              <div
                :style="{height: b / 53 + 'px',lineHeight:b / 53 + 'px', fontSize:b / 128 + 'px',}"
                style="padding: 0 20px;"
                :class="LastestTime == 'month' ? 'btnMini isActive' : 'btnMini'"
                @click="
							  LastestTime = 'month';
							  getLastestTime();
							"
              >Latest 30 days</div>
              <div
                :style="{height: b / 53 + 'px',lineHeight:b / 53 + 'px', fontSize:b / 128 + 'px'}"
                style="padding: 0 20px;"
                :class="LastestTime == 'year' ? 'btnMini isActive' : 'btnMini'"
                @click="
							  LastestTime = 'year';
							  getLastestTime();
							"
              >Latest 365 days</div>
            </div>
            <div
              class="contentBetween"
              :style="{height: b / 53 + 'px',lineHeight:b / 53 + 'px', fontSize:b / 128 + 'px'}"
              :class="Lastests == 'more' ? ' ' : ''"
            >
              <div
                :style="{width:b / 17.4 + 'px',height: b / 53 + 'px',lineHeight:b / 53 + 'px', fontSize:b / 128 + 'px'}"
                class="isActive btnMini"
                style="margin-left: 14px;"
              >ALL Data</div>
              <div
                @click="
								  Lastests = 'more';
								  getLastestsTwo('moreEvent');
								"
                style="display: inline-block;font-size: 18px;font-weight: 700;color: #168ec7;cursor: pointer;"
              >
                more
                <sup style="font-size: 10px;">+</sup>
              </div>
              <!-- <div style="font-weight: 700;color: #168ec7;">+</div> -->
            </div>
          </div>
        </div>
        <div style="display: flex;">
          <div class="Progress" :style="{width: b / 3 + 'px'}">
            <div class="lineLi" v-for="(item, i) in dataList" :key="i" @click="eventInfo(item)">
              <div :class="dataColor2[i] != undefined ? dataColor2[i] : 'left_li'">
                <div class="lineName" :title="item.title">{{ item.title }}</div>
                <el-progress
                  :text-inside="true"
                  :percentage="(item.count / 100) * 100"
                  :show-text="false"
                ></el-progress>
              </div>
              <div class="right_li">
                <div class="number">{{ item.count }}</div>
                <div class="type">message</div>
              </div>
            </div>
            <div class="descSec" style="position: absolute;bottom:5px">
              <!-- <p>Source: Astrobursthub</p> -->
              <p style="display: flex; align-items: center; height: 15px">
                <span class="dataBg"></span>
                <span style="margin-left: 2px">Recent Hot Events</span>
              </p>
            </div>
          </div>
          <div style="width: 30px;"></div>
          <div class="Progress" :style="{width: b / 3 + 'px'}">
            <div class="lineLi" v-for="(item, i) in dataList2" :key="i" @click="eventInfo(item)">
              <div :class="dataColor[i] != undefined ? dataColor[i] : 'left_li'">
                <div class="lineName" :title="item.title">{{ item.title }}</div>
                <el-progress
                  :text-inside="true"
                  :percentage="(item.count / 500) * 100"
                  :show-text="false"
                ></el-progress>
              </div>
              <div class="right_li">
                <div class="number">{{ item.count }}</div>
                <div class="type">message</div>
              </div>
            </div>
            <div class="descSec" style="position: absolute;bottom:5px">
              <!-- <p>Source: Astrobursthub</p> -->
              <p style="display: flex; align-items: center; height: 15px">
                <span class="dataBg"></span>
                <span style="margin-left: 2px">
                  <!-- Data may be incomplete for the current day. -->
                  The Hot Events in all data.
                </span>
              </p>
            </div>
          </div>
        </div>
        <!-- <div class="cont" :style="{marginLeft:b / 22 + 'px'}">
					<div class="cardTitle" :style="{fontSize:b / 54.8 + 'px'}">The Hot Events</div>
					<div class="cardDesc" :style="{fontSize:b / 137 + 'px',width: b / 4.3 + 'px',marginTop:b / 53 + 'px'}">
						{{ hotEventsDesc }}
					</div>
					<div class="cardButton" :style="{fontSize:b / 120 + 'px',marginTop:b / 19 + 'px',width:b / 11 + 'px'}" @click="to_Router('HotEvents')">
						REQUEST ACCESS
					</div>
        </div>-->
      </div>
      <div class="fourCard" :style="{width:b / 1.6 + 'px',padding:(b / 48 + 'px', b / 71 + 'px')}">
        <div class="cardTitle" style="white-space: nowrap" :style="{fontSize:b / 54.8 + 'px'}">
          Latest
          Messages
        </div>
        <div class="top">
          <!-- <div class="cardTitle" style="white-space: nowrap;opacity: 0;" :style="{fontSize:b / 54.8 + 'px'}">Lastest
          Message</div>-->
          <div class="anNi" style="padding-right:10px">
            <div style="display: flex;">
              <div
                :style="{width:b / 17.4 + 'px',height: b / 53 + 'px',lineHeight:b / 53 + 'px', fontSize:b / 128 + 'px'}"
                :class="Lastest == 'Notices' ? 'btnMini isActive' : 'btnMini'"
                @click="
							  Lastest = 'Notices';
							  getLastest();
							"
              >Notices</div>
              <div
                :style="{width:b / 17.4 + 'px',height: b / 53 + 'px',lineHeight:b / 53 + 'px', fontSize:b / 128 + 'px'}"
                :class="Lastest == 'Circulars' ? 'btnMini isActive' : 'btnMini'"
                @click="
							  Lastest = 'Circulars';
							  getLastest();
							"
              >Circulars</div>
              <div
                :style="{width:b / 17.4 + 'px',height: b / 53 + 'px',lineHeight:b / 53 + 'px', fontSize:b / 128 + 'px'}"
                :class="Lastest == 'ATel' ? 'btnMini isActive' : 'btnMini'"
                @click="
							  Lastest = 'ATel';
							  getLastest();
							"
              >ATel</div>
              <!-- <div :style="{width:b / 17.4 + 'px',height: b / 53 + 'px',lineHeight:b / 53 + 'px', fontSize:b / 128 + 'px'}"
														:class="Lastest == 'Customize' ? 'btnMini isActive' : 'btnMini'" @click="
							  Lastest = 'Customize';
							  getLastest();
							">
														Customize
              </div>-->
            </div>
            <div
              :style="{height: b / 53 + 'px',lineHeight:b / 53 + 'px', fontSize:b / 128 + 'px'}"
              :class="Lastests == 'more' ? ' ' : ''"
              @click="
								  Lastests = 'more';
								  getLastestsTwo('moreMessage');
								"
              style="display: flex;align-items: center;"
            >
              <div
                style="display: inline-block;font-size: 18px;font-weight: 700;color: #168ec7;cursor: pointer;"
              >
                more
                <sup style="font-size: 10px;">+</sup>
              </div>
            </div>
          </div>
        </div>

        <div class="bottom" style="padding: 0 0px;">
          <div class="ul">
            <div
              class="li"
              v-for="(item, index) in lastList"
              :key="index"
              @click="queryDetil(item.id)"
            >
              <div style="display:flex;align-items:center" class="bottomLiLeft">
                <span></span>
                <div
                  v-if="Lastest == 'Notices'"
                  class="title titleUl"
                  :style="{fontSize:b / 120 + 'px'}"
                >{{ item.noticeType }}</div>
                <div
                  v-if="Lastest == 'Circulars'"
                  class="title titleUl"
                  :style="{fontSize:b / 120 + 'px'}"
                >{{ item.subject }}</div>
                <div
                  v-if="Lastest == 'ATel'"
                  class="title titleUl"
                  :style="{fontSize:b / 120 + 'px'}"
                >{{ item.title }}</div>
              </div>
              <div class="time" :style="{fontSize:b / 160 + 'px'}">{{ item.nowDate }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="oneCard"
				:style="{width:b / 1.6 + 'px',height:b / 4.45 + 'px',padding:(b / 48 + 'px', b / 71 + 'px')}">
				<div class="renxing" :style="{width:b / 14 + 'px',height:b / 15 + 'px',left:b / 8 + 'px',bottom:b / 83 + 'px'}">
					<img src="@/assets/slices_slices/6.svg" alt="" />
				</div>
				<div class="oneCardCont">
					<div class="cont">
						<div class="cardTitle" style="white-space: nowrap" :style="{fontSize:b / 54.8 + 'px'}">
							Number Of Events Last Week
						</div>
						<div class="cardDesc" :style="{fontSize:b / 137 + 'px',width: b / 4.3 + 'px',marginTop:b / 53 + 'px'}">
							{{ lastWeekEventsDesc }}
						</div>
						<div class="cardButton2" :style="{fontSize:b / 120 + 'px',bottom:b / 25.6 + 'px',width:b / 11 + 'px',}" @click="to_Router('EVENTS')">
							REQUEST ACCESS
						</div>
					</div>
					<div class="char" :style="{width: b / 2.7 + 'px',height: b / 4.5 + 'px'}">
						<div class="change_time">
							<div :style="{width:b / 17.4 + 'px',height: b / 53 + 'px',lineHeight:b / 53 + 'px', fontSize:b / 128 + 'px'}"
								:class="time == 'week' ? 'week isActive' : 'week'" @click="
			      time = 'week';
			      getLoadEcharts();
			      getTime();
			    ">
								Week
							</div>
							<div :style="{width:b / 17.4 + 'px',height: b / 53 + 'px',lineHeight:b / 53 + 'px',fontSize:b / 128 + 'px'}"
								:class="time == 'month' ? 'month isActive' : 'month'" @click="
			      time = 'month';
			      getLoadEcharts();
			      getTime();
			    ">
								Month
							</div>
						</div>
						<div class="echartsLine" id="echart" :style="{width: b / 2.7 + 'px',height: b / 5 + 'px'}">
						</div>
					</div>
				</div>
      </div>-->

      <!-- height:b / 4.45 + 'px' -->
      <div class="oneCard" :style="{width:b / 1.6 + 'px',padding:(b / 48 + 'px', b / 71 + 'px')}">
        <div
          class="cardTitle"
          style="white-space: nowrap;"
          :style="{fontSize:b / 54.8 + 'px'}"
        >Statistics of Latest Events & Messages</div>
        <div class="oneCardCont">
          <div class="change_time">
            <div
              :style="{height: b / 53 + 'px',lineHeight:b / 53 + 'px', fontSize:b / 128 + 'px'}"
              style="padding: 0 20px;"
              :class="time == 'week' ? 'week isActive' : 'week'"
              @click="
					  time = 'week';
					  getLoadEcharts();
					  getTime();
					"
            >Latest 7 days</div>
            <div
              :style="{height: b / 53 + 'px',lineHeight:b / 53 + 'px',fontSize:b / 128 + 'px'}"
              style="padding: 0 20px;"
              :class="time == 'month' ? 'month isActive' : 'month'"
              @click="
					  time = 'month';
					  getLoadEcharts();
					  getTime();
					"
            >Latest 30 days</div>
          </div>
          <!-- <div class="cont" style="margin-top: 20px;"> -->
          <!-- <div class="cardTitle" style="white-space: nowrap" :style="{fontSize:b / 54.8 + 'px'}">
							Number Of Events Last Week
						</div>
						<div class="cardTitle" style="white-space: nowrap" :style="{fontSize:b / 54.8 + 'px'}">
							Number of Lastest Message
          </div>-->
          <!-- </div> -->
          <!-- :style="{height: b / 4.5 + 'px'}" -->
          <div class="char">
            <div style="flex: 1;">
              <div
                class="echartsLine"
                id="echart"
                :style="{width: b / 3.4 + 'px',height: b / 5 + 'px'}"
              ></div>
              <div class="descSec" style="padding-bottom: 30px;margin-top: -30px;padding-left:30px">
                <p style="display: flex; align-items: center; height: 15px">
                  <span class="dataBg"></span>
                  <span style="margin-left: 2px">Number Of Latest Events</span>
                </p>
              </div>
            </div>
            <div style="flex: 1;">
              <div
                class="echartsLine"
                id="echart2"
                :style="{width: b / 3.4 + 'px',height: b / 5 + 'px'}"
              ></div>
              <div class="descSec" style="margin-top: -30px;padding-left:30px">
                <p style="display: flex; align-items: center; height: 15px">
                  <span class="dataBg"></span>
                  <span style="margin-left: 2px">Number Of Latest Messages</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="upTime">update time:{{unDateTime}}</div> -->
        <div class="descSec" style="text-align: right;margin-top:-15px">
          <p>
            <span class="dataBg"></span>
            <span style="margin-left: 2px">Update Time:{{unDateTime}}</span>
          </p>
          <p style=" height: 15px">
            <span class="dataBg"></span>
            <span style="margin-left: 2px">Data may be incomplete for the current day.</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import IndexHeader from "../components/header/indexHeader";
import { format } from "../utils/index.js";
export default {
  name: "indexPage",
  components: {
    IndexHeader
  },
  data() {
    return {
      showImgBg: false,
      Lastest: "Notices",
      time: "month",
      indexShow: false,
      activeName: "1",
      navActive: "HOME",
      dataList: [],
      dataColor: ["caolv", "chengse", "zise", "shenzi", "lvse", "lanse"],
      dataColor2: ["lanse6", "lanse5", "lanse4", "lanse3", "lanse2", "lanse1"],
      access_token: "",
      showFixed: false,
      text_list: [],
      lastList: [],
      dateList: [],
      code: "",
      indexData: {},
      description: "",
      hotEventsDesc: "",
      hotEventsLink: "",
      title: "",
      lastWeekEventsDesc: "",
      lastWeekEventsLink: "",
      timer: undefined,
      urlList: [],
      c: "",
      b: "",
      Lastests: "GRB",
      // Lastests: "ALL",
      LastestTime: "year",
      unDateTime: "",
      dataList2: [],
      storageId: ""
    };
  },
  created() {
    this.urlList = JSON.parse(localStorage.getItem("urlList"));
    console.log("urlList");
    console.log(this.urlList);
    this.getCarouselData();
  },
  mounted() {
    localStorage.removeItem("metaTitle");
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://code.jquery.com/jquery-1.10.1.min.js";
    document.body.appendChild(script);
    let script2 = document.createElement("script");
    script2.type = "text/javascript";
    script2.src =
      "https://aladin.cds.unistra.fr/AladinLite/api/v3/latest/aladin.js";
    document.body.appendChild(script2);
    if (localStorage.getItem("access_token")) {
      this.access_token = localStorage.getItem("access_token");
    } else {
      this.access_token = "";
    }

    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("scroll", this.scrollToTop1, true);
    });
    window.addEventListener("scroll", this.scrollToTop1, true);
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        //监听浏览器窗口大小改变
        this.getIndexData();
      });
    });
    this.getIndexData();
    this.getUrlSearchObj();
    this.getDataTwo();
    this.getData();
    this.getHomeData();
  },
  methods: {
    getTimeCreate() {
      this.$fetchGet("/cms-middle/cmsSite/updateTime").then(res => {
        this.unDateTime = res.data;
      });
    },
    getLastestsTwo(index) {
      if (index == "moreMessage") {
        this.$router.push("/message");
      } else {
        this.$router.push("/events");
      }
    },
    getIndexData() {
      let a = document.getElementsByClassName("header");
      this.b = a[0].clientWidth;
      this.c = (this.b * 525) / 1920;
      // document.getElementsByClassName('is-active').style.width = this.b
    },
    goSearch(index) {
      if (index == 1) {
        window.open("http://english.ihep.cas.cn/", "_blank");
      } else {
        window.open("https://www.nhepsdc.cn/", "_blank");
      }
    },
    getLastestTime() {
      if (this.LastestTime == "month") {
        // var beginTriggerTime = this.getStartTime()
        // var endTriggerTime = this.getEndTime()

        var oneDay = 24 * 60 * 60 * 1000;
        var endTriggerTime = new Date(Date.now());
        endTriggerTime = this.formatterDate(endTriggerTime, "yyyy-MM-dd");
        var beginTriggerTime = new Date(Date.now() - 30 * oneDay);
        beginTriggerTime = this.formatterDate(beginTriggerTime, "yyyy-MM-dd");
      } else {
        var beginTriggerTime = this.getStartYear();
        var endTriggerTime = this.getEndYear();
      }
      var path =
        "/cms-middle/astronEvent/hot?pageSize=6" +
        "&beginTriggerTime=" +
        beginTriggerTime +
        "&endTriggerTime=" +
        endTriggerTime;
      this.$fetchGet(path)
        .then(result => {
          this.dataList = result.list;
        })
        .catch(err => {});
      this.$fetchGet("/cms-middle/astronEvent/hot?pageSize=6")
        .then(result => {
          this.dataList2 = result.list;
        })
        .catch(err => {});
    },
    getStartYear() {
      let date = new Date();
      let year = date.getFullYear();
      return year + "-" + "1-1";
    },
    getEndYear() {
      let date = new Date();
      let year = date.getFullYear();
      return year + "-" + "12-31";
    },
    getStartTime() {
      let date = new Date();
      date.setDate(1);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      month = month > 10 ? month : "0" + month;
      let day = date.getDate();
      day = day > 10 ? day : "0" + day;
      return year + "-" + month + "-" + day;
    },
    getEndTime() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      month = month > 10 ? month : "0" + month;
      let nextMonthFirthDay = new Date(year, month, 1);
      let oneDay = 1000 * 60 * 60 * 24;
      let endDay = new Date(nextMonthFirthDay - oneDay);
      let day = endDay.getDate();
      day = day > 10 ? day : "0" + day;
      return year + "-" + month + "-" + day;
    },
    // 获取轮播图
    getCarouselData() {
      this.$fetchGet("/cms-middle/cmsRotation/all")
        .then(result => {
          if (this.urlList == null || this.urlList == "") {
            console.log("/cmsRotation/all");
            this.urlList = result.list;
          }
        })
        .catch(err => {});
    },
    goLink(item) {
      window.location.href = item.link;
    },
    // showDetail(item) {
    // 	console.log(item.id)
    // 	if(this.storageId != item.id){
    // 		for (var i = 0; i < this.text_list.length; i++) {
    // 			if (this.text_list[i].show = true) {
    // 				this.text_list[i].show = false
    // 			}
    // 		}
    // 		item.show = !item.show
    // 	}else{
    // 		item.show = !item.show
    // 	}
    // 	this.storageId = item.id
    // },
    showDetail(item) {
      for (var i = 0; i < this.text_list.length; i++) {
        if ((this.text_list[i].show = true)) {
          this.text_list[i].show = false;
        }
      }
      item.show = !item.show;
    },
    goDetail(item) {
      if (item.show == true) {
        this.$router.push({
          path: "/eventsDetail",
          query: {
            eventId: item.id
          }
        });
      }
    },
    //跳转events详情页
    itemid(row) {
      // this.$router.push("/eventsDetail?eventId=" + row.id);
      this.$router.push({
        path: "/eventsDetail",
        query: {
          eventId: row.id
        }
      });
    },
    getHomeData() {
      this.$fetchGet("/cms-middle/cmsSite/config?type=home")
        .then(result => {
          this.indexData = result.config;
          this.description = result.config.description.description;
          this.hotEventsDesc = result.config.hotEventsDesc.description;
          this.hotEventsLink = result.config.hotEventsLink.description;
          this.lastWeekEventsDesc =
            result.config.lastWeekEventsDesc.description;
          this.lastWeekEventsLink =
            result.config.lastWeekEventsLink.description;
          this.title = result.config.title.description;
        })
        .catch(err => {});
    },
    //跳转message详情页
    queryDetil(id) {
      if (this.Lastest == "Notices") {
        this.$router.push({
          path: "/Notice",
          query: {
            id: id
          }
        });
      } else if (this.Lastest == "Circulars") {
        this.$router.push({
          path: "/Circulars",
          query: {
            id: id
          }
        });
      } else if (this.Lastest == "Customize") {
        this.$router.push({
          path: "/Customize",
          query: {
            id: id
          }
        });
      } else if (this.Lastest == "ATel") {
        this.$router.push({
          path: "/Atel",
          query: {
            id: id
          }
        });
      }
    },

    show_word(list) {
      let aladin;
      if (A) {
        console.log(A);
        clearInterval(this.timer);
      }
      A.init.then(() => {
        aladin = A.aladin("#aladin-lite-div", {
          fov: 360,
          projection: "AIT",
          cooFrame: "equatorial",
          showCooGridControl: true,
          showSimbadPointerControl: true,
          showCooGrid: true,
          survey: "P/DSS2/color",
          // survey:'color',
          // reticleColor:'red',
          allskyRingColor: "red"
        });
        // list;
        if (list != undefined) {
          if (list.length == 0) {
            console.log(123);
          } else {
            for (let i in list) {
              // item.ra
              if (list[i].ra != "" && list[i].declination != "") {
                console.log(123444);
                var marker1 = A.marker(list[i].ra, list[i].declination, {
                  popupTitle: list[i].title
                  // popupDesc: list[i],
                });
                var markerLayer = A.catalog({
                  color: "red"
                });
                aladin.addCatalog(markerLayer);
                markerLayer.addSources([marker1]);
              } else {
                console.log(123);
              }
            }
          }
        }
        // document.getElementsByClassName("aladin-imageCanvas")[0].style.width =
        // 	"calc(100% - 100px)!important";
        // document.getElementsByClassName("aladin-catalogCanvas")[0].style.width =
        // 	"calc(100% - 100px)!important";
        // document.getElementsByClassName("zoomMinus")[0].style.display = "none";
        // document.getElementsByClassName("zoomPlus")[0].style.display = "none";
        // document.getElementsByClassName("aladin-fov")[0].style.display = "none";
        document.getElementsByClassName(
          "aladin-catalogCanvas"
        )[0].style.boxShadow = "rgba(0, 0, 0, 0.6) 7px -6px 13px";
        // document.getElementsByClassName(
        // 	"aladin-projSelection"
        // )[0].style.display = "none";
        // document.getElementsByClassName("aladin-location")[0].style.display =
        // 	"none";
        // document.getElementsByClassName(
        // 	"aladin-layersControl"
        // )[0].style.display = "none";
        // document.getElementsByClassName("aladin-gotoControl")[0].style.display =
        // 	"none";
        // document.getElementsByClassName(
        // 	"aladin-cooGridControl"
        // )[0].style.display = "none";
        // document.getElementsByClassName(
        // 	"aladin-cooGridControl"
        // )[0].style.display = "none";
        // document.getElementsByClassName(
        // 	"aladin-simbadPointerControl"
        // )[0].style.display = "none";
        // document.getElementsByClassName(
        // 	"aladin-fullscreenControl"
        // )[0].style.display = "none";
        // document.getElementsByClassName("aladin-logo")[0].style.display =
        // 	"none";
      });
    },
    getUrlSearchObj() {
      const pageInfo = window.location.search.split("?");
      if (pageInfo.length > 1) {
        const res = {};
        const search = pageInfo[1];
        const strs = search.split("&");
        for (let i = 0; i < strs.length; i++) {
          res[strs[i].split("=")[0]] = decodeURIComponent(
            strs[i].split("=")[1]
          );
        }
        this.code = res.code;
        if (res.code != undefined) {
          this.getToken();
          localStorage.setItem("code", res.code);
        }
        return res.code;
      } else {
        return null;
      }
    },
    getToken() {
      this.$fetchGet("/auth-open/callback?code=" + this.code)
        .then(result => {
          if (result.access_token != undefined) {
            localStorage.setItem("access_token", result.access_token);
            localStorage.setItem("userInfo", result.userInfo);
            this.access_token =
              localStorage.getItem("access_token") != undefined
                ? localStorage.getItem("access_token")
                : "";
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    scrollToTop1() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.showFixed = true;
      //为了计算距离顶部的高度，当高度大于50显示回顶部图标，小于50则隐藏
      if (scrollTop > 1) {
        this.$refs.indexHeader.imgBg = false;
        this.$refs.indexHeader.scrollTo = true;
      } else {
        this.showFixed = false;
        this.$refs.indexHeader.scrollTo = false;
      }
    },
    formatterDate(date, fmt) {
      let nowDate = {
        yyyy: date.getFullYear(), // 年
        MM: date.getMonth() + 1, // 月份
        dd: date.getDate(), //日
        hh: date.getHours(),
        mm: date.getMinutes(),
        ss: date.getSeconds()
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      for (var k in nowDate) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? nowDate[k]
              : ("00" + nowDate[k]).substr(("" + nowDate[k]).length)
          );
        }
      }
      return fmt;
    },
    getTime() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      month = month > 10 ? month : "0" + month;
      let day = date.getDate();
      day = day > 10 ? day : "0" + day;
      var oneDay = 24 * 60 * 60 * 1000;
      if (this.time == "week") {
        var endTriggerTime = year + "-" + month + "-" + day;
        var beginTriggerTime = new Date(Date.now() - 7 * oneDay);
        beginTriggerTime = this.formatterDate(beginTriggerTime, "yyyy-MM-dd");
      } else {
        var endTriggerTime = new Date(Date.now());
        endTriggerTime = this.formatterDate(endTriggerTime, "yyyy-MM-dd");
        var beginTriggerTime = new Date(Date.now() - 30 * oneDay);
        beginTriggerTime = this.formatterDate(beginTriggerTime, "yyyy-MM-dd");
      }

      var path =
        "/cms-middle/astronMessage/number?pageSize=6&beginTriggerTime=" +
        beginTriggerTime +
        "&endTriggerTime=" +
        endTriggerTime;

      this.$fetchGet(path).then(result => {
        let data = [];
        let newData = [];
        let date = new Date();
        if (this.time == "week") {
          data = this.$getMonthYMD(date, 7, true);
          for (let i = 0; i < 7; i++) {
            newData.push("");
          }
        } else {
          data = this.$getMonthYMD(date, 30, true);
          for (let i = 0; i < 30; i++) {
            newData.push("");
          }
        }
        for (let j in result.list) {
          for (let i in data) {
            if (result.list[j].triggerTimeText == data[i]) {
              newData[i] = result.list[j].count;
            }
          }
        }
        this.dateList = newData;
        this.getLoadEcharts2();
      });

      this.$fetchGet("/cms-middle/astronEvent/" + this.time)
        .then(result => {
          let data = [];
          let newData = [];
          let date = new Date();
          if (this.time == "week") {
            data = this.$getMonthYMD(date, 7, true);
            for (let i = 0; i < 7; i++) {
              newData.push("");
            }
          } else {
            data = this.$getMonthYMD(date, 30, true);
            for (let i = 0; i < 30; i++) {
              newData.push("");
            }
          }
          for (let j in result.list) {
            for (let i in data) {
              if (result.list[j].triggerTimeText == data[i]) {
                newData[i] = result.list[j].count;
              }
            }
          }
          this.dateList = newData;
          this.getLoadEcharts();
        })
        .catch(err => {});
    },
    getData() {
      this.getTime();
      var path =
        "/cms-middle/astronEvent/latest?pageSize=6" + "&type=" + this.Lastests;
      this.$fetchGet(path)
        .then(result => {
          for (var i = 0; i < result.list.length; i++) {
            result.list[i].show = false;
          }
          this.text_list = result.list;
          this.activeName = result.list[0].id;
          // this.timer = setInterval(() => {
          // 	this.show_word(result.list);
          // }, 2000);
        })
        .catch(err => {});
    },
    getDataTwo() {
      this.getTime();
      var path =
        "/cms-middle/astronEvent/latest/union?type=SGR,GRB,IceCube&pageSize=6";
      this.$fetchGet(path)
        .then(result => {
          for (var i = 0; i < result.list.length; i++) {
            result.list[i].show = false;
          }
          this.timer = setInterval(() => {
            this.show_word(result.list);
          }, 2000);
        })
        .catch(err => {});
      this.getLastest();
      this.getLastestTime();
      this.getTimeCreate();
    },
    getLastests(type) {
      this.Lastests = type;
      if (type == "more") {
        this.$router.push("/message");
      } else {
        this.getData();
      }
    },
    getLastest() {
      let type = "";
      if (this.Lastest == "Notices") {
        type = "astronNotice";
      } else if (this.Lastest == "Circulars") {
        type = "astronCircular";
      } else if (this.Lastest == "ATel") {
        type = "astronAtel";
      } else if (this.Lastest == "Customize") {
        type = "astronCustomize";
      }
      // if(this.Lastest == 'ATel'){
      // 	var url = '/cms-middle/astronAtel/search'
      // }else{
      var url = "/cms-middle/" + type + "/list?pageSize=18";
      // }
      this.$fetchGet(url)
        .then(result => {
          this.lastList = result.page.records;
          for (var i = 0; i < this.lastList.length; i++) {
            if (this.lastList[i].noticeDate) {
              this.lastList[i].nowDate = format(
                this.lastList[i].noticeDate,
                "yyyy-MM-dd hh:mm:ss"
              );
            }
            // if (this.lastList[i].createDate) {
            // 	this.lastList[i].nowDate = format(this.lastList[i].createDate,
            // 		'yyyy-MM-dd hh:mm:ss')
            // }
            if (this.lastList[i].circularTime) {
              this.lastList[i].nowDate = format(
                this.lastList[i].circularTime,
                "yyyy-MM-dd hh:mm:ss"
              );
            }
            if (this.lastList[i].atelTime) {
              this.lastList[i].nowDate = format(
                this.lastList[i].atelTime,
                "yyyy-MM-dd hh:mm:ss"
              );
            }
          }
        })
        .catch(err => {});
    },
    eventInfo(item) {
      //进入详情
      this.$router.push("/eventsDetail?eventId=" + item.id);
    },
    to_Router(sub) {
      if (this.$route.meta.title == sub) {
        window.location.reload();
      } else {
        if (sub == "SUBMIT") {
          this.$router.push("/submit");
        } else if (sub === "HOME") {
          this.$router.push("/indexPage");
        } else if (sub === "SUBSCRIBE") {
          this.$router.push("/subscribe");
        } else if (sub === "MESSAGE") {
          this.$router.push("/message");
        } else if (sub === "EVENTS") {
          // this.$router.push("/events");
          this.$router.push(this.indexData.lastWeekEventsLink.description);
        } else if (sub === "HotEvents") {
          this.$router.push(this.indexData.hotEventsLink.description);
        }
      }
    },
    getLoadEcharts() {
      var chartDom = document.getElementById("echart");
      var myChart = this.$echarts.init(chartDom);
      var option;
      var xAxis = {};
      let date = new Date();
      if (this.time == "week") {
        xAxis = {
          type: "category",
          data: this.$getMonth(date, 7, true)
        };
      } else {
        xAxis = {
          type: "category",
          data: this.$getMonth(date, 30, true)
        };
      }
      option = {
        xAxis: xAxis,
        yAxis: {
          type: "value",
          position: "right"
        },
        // grid: {
        //         left: '0%',
        //         right: '0%',
        //         bottom: '2%',
        //         top: '4%',
        //         containLabel: true,
        //       },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        series: [
          {
            data: this.dateList,
            type: "bar",
            itemStyle: {
              color: "#168EC7"
            }
            // itemStyle: {
            // 	color: arg => {
            // 		if(arg.value > 2.5){
            // 			return '#168EC7'
            // 		}else if(arg.value > 1){
            // 			return '#ff0000'
            // 		}else{
            // 			return 'yellow'
            // 		}
            // 	}
            // },
          }
        ]
      };

      myChart.setOption(option);
    },
    getLoadEcharts2() {
      var chartDom = document.getElementById("echart2");
      var myChart = this.$echarts.init(chartDom);
      var option;
      var xAxis = {};
      let date = new Date();
      if (this.time == "week") {
        xAxis = {
          type: "category",
          data: this.$getMonth(date, 7, true)
        };
      } else {
        xAxis = {
          type: "category",
          data: this.$getMonth(date, 30, true)
        };
      }
      option = {
        xAxis: xAxis,
        yAxis: {
          type: "value",
          position: "right"
        },
        // grid: {
        //         left: '0%',
        //         right: '0%',
        //         bottom: '2%',
        //         top: '4%',
        //         containLabel: true,
        //       },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        series: [
          {
            data: this.dateList,
            type: "bar",
            itemStyle: {
              color: "#168EC7"
            }
            // itemStyle: {
            // 	color: arg => {
            // 		if(arg.value > 2.5){
            // 			return '#168EC7'
            // 		}else if(arg.value > 1){
            // 			return '#ff0000'
            // 		}else{
            // 			return 'yellow'
            // 		}
            // 	}
            // },
          }
        ]
      };

      myChart.setOption(option);
    }
  }
};
</script>
<style lang="less">
.el-collapse {
  width: 440px !important;
}

.text_list .li {
  // height: (24*3)px;
  height: var(--c) px;
}
.el-carousel__container {
  height: 100% !important;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.titleStyle {
  width: 250px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.contentBetween {
  display: flex;
  align-items: center;
  width: 50%;
  justify-content: space-between;
}
.upTime {
  position: absolute;
  right: 10px;
  bottom: 5px;
  font-size: 14px;
  color: #000000;
}
.anNi {
  display: flex;
  align-items: baseline;
  width: 100%;
  justify-content: space-between;
}

.actives {
  color: #000000 !important;
}

.activea {
  background-color: #f3f3f3;
}

.btnMini {
  /* width: 110px; */
  height: 36px;
  background: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 25px;
  line-height: 36px;
  cursor: pointer;
  text-align: center;
  margin-right: 10px;
  font-size: 15px;
  font-weight: 600;
}

.btnMini.isActive {
  background: #168ec7;
  color: #fff;
  font-weight: 600;
}

.change_time {
  display: flex;
  justify-content: flex-start;
  padding: 15px 0;
}

.week {
  width: 110px;
  height: 36px;
  background: #ffffff;
  border-radius: 25px;
  line-height: 36px;
  color: #333333;
  text-align: center;
  cursor: pointer;
  font-size: 15px;
  font-weight: Regular;
}

.week.isActive,
.month.isActive {
  background: #168ec7;
  color: #fff;
  font-size: 15px;
}

.month {
  width: 110px;
  height: 36px;
  background: #ffffff;
  border-radius: 25px;
  margin-right: 28px;
  margin-left: 10px;
  line-height: 36px;
  color: #333333;
  font-size: 15px;
  cursor: pointer;
}

.right {
  display: flex;
  align-items: center;
}

.userLogin {
  width: 41px;
  height: 41px;
  background: #168ec7;
  border-radius: 50%;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  margin-right: 50px;
  margin-left: 25px;
  color: #fff;
}

.showChange {
  position: relative;
}

.userList p {
  margin: 0 8px;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
}

.userList p:hover {
  background: #e7f3f9;
  cursor: pointer;
}

.descSec {
  text-align: left;
  font-size: 10px;
}

.descSec p {
  margin: 0;
}

.descSec .dataBg {
  width: 10px;
  height: 10px;
  background: url(@/assets/slices_slices/dataBlock_03.png) no-repeat center
    center;
  background-size: 100% 100%;
  display: inline-block;
}

.wrapper {
  width: 100%;
  margin: 0 auto;
}

.diqiu1 {
  position: absolute;
  /* width: 40.5%; */
  height: 392px;
  right: 0.458%;
  /* width: 679px;
		height: 422px;
		right: 22px; */
  top: 1px;
}

.renxing {
  position: absolute;
  width: 7.01%;
  height: 94px;
  /* width: 134px;
		height: 125px; */
  left: 31.3%;
  /* top: 23%; */
}

.feixingqi {
  position: absolute;
  width: 22.2%;
  height: 164px;
  left: -1%;
  /* width: 428px;
		height: 219px;
		left: -1%; */
  top: 48%;
}

.diqiu2 {
  position: absolute;
  width: 23.9%;
  height: 377px;
  right: 5%;
  /* width: 420px;
		height: 402px;
		right: 43px; */
  bottom: -5%;
}

.diqiu1 img,
.renxing img,
.feixingqi img,
.diqiu2 img {
  width: 100%;
  height: auto;
  position: absolute;
  bottom: 0;
  right: 0;
}

.boxContent {
  /* background: url(@/assets/slices_slices/2.svg) no-repeat center center; */
  background-size: 100% 100%;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.el-carousel__item:nth-child(2n) {
  height: 570px;
  width: 100%;
  /* background: url(@/assets/slices_slices/banner-01.png) no-repeat center center; */
  /* background-size: 100% 100%; */
}

.el-carousel__item:nth-child(2n + 1) {
  height: 570px;
  width: 100%;
  /* background: url(@/assets/slices_slices/banner-02.png) no-repeat center center; */
  /* background-size: 100% 100%; */
}

.el-carousel__item:nth-child(2n) img {
  height: 570px;
  width: 100%;
}

.el-carousel__item:nth-child(2n + 1) img {
  height: 570px;
  width: 100%;
}

.el-carousel {
  height: 570px;
  width: 100%;
}

.header {
  /* height: 570px; */
  width: 100%;
  position: relative;
}

.logo {
  /* width: 125px; */
  font-size: 30px;
  font-family: Alibaba Sans;
  font-weight: normal;
  color: #168ec7;
  margin-left: 43px;
}

.fixheaderTwo {
  width: 100%;
  height: 68px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav {
  color: #666666;
  font-size: 15px;
  display: flex;
  width: 509px;
  justify-content: space-between;
  margin-right: 30px;
}

.nav p {
  cursor: pointer;
  margin: 0 !important;
}

.login {
  color: #fff;
  font-size: 11px;
  position: absolute;
  top: 40px;
  right: 170px;
  width: 75px;
  height: 24px;
  background: #168ec7;
  border-radius: 12px 12px 12px 12px;
  line-height: 26px;
  cursor: pointer;
}

.reg {
  color: #474747;
  font-size: 11px;
  position: absolute;
  top: 40px;
  right: 80px;
  width: 75px;
  height: 24px;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;
  line-height: 26px;
  cursor: pointer;
}

.nav_title {
  font-size: 50px;
  font-family: Arial-BoldMT-, Arial-BoldMT;
  font-weight: normal;
  color: #ffffff;
}

.content {
  top: 180px;
  position: absolute;
  text-align: left;
  left: 110px;
  /* flex: 1; */
}

.desc {
  width: 480px;
  font-size: 17px;
  font-family: ArialMT-, ArialMT;
  font-weight: normal;
  color: #ffffff;
  line-height: 29px;
  margin-top: 29px;
}

.button {
  width: 127px;
  height: 35px;
  background: #2468f2;
  border-radius: 17px 17px 17px 17px;
  opacity: 1;
  font-size: 11px;
  font-family: ArialMT-, ArialMT;
  font-weight: normal;
  color: #ffffff;
  margin-top: 70px;
  text-align: center;
  line-height: 36px;
  cursor: pointer;
}

.h1Title {
  width: 623px;
  height: 98px;
  font-size: 42px;
  font-family: Arial-BoldMT-, Arial-BoldMT;
  font-weight: normal;
  color: #168ec7;
  line-height: 49px;
  margin-top: 35px;
  position: relative;
  z-index: 99;
}

.h1Desc {
  width: 450px;
  font-size: 11px;
  font-family: ArialMT-, ArialMT;
  font-weight: normal;
  color: #222222;
  line-height: 18px;
  margin-top: 15px;
  margin-bottom: 38px;
  position: relative;
  z-index: 99;
}

.oneCard {
  /* min-width: 725px; */
  /* width: 62.5%; */
  width: 1050px;
  /* height: 321px; */
  /* height: 428px; */
  /* background: rgba(246, 246, 246, 0.7); */
  background: rgba(204, 204, 204, 0.3);
  box-shadow: 0px 4px 11px 0px rgba(0, 0, 0, 0.10000000149011612);
  border-radius: 11px 11px 11px 11px;
  position: relative;
  z-index: 99;
  /* padding-bottom: 0 !important; */
  position: relative;
  margin-bottom: 40px;
}

.oneCardCont {
  /* display: flex; */
  /* min-width: 725px; */
  width: 100%;
  /* height: 321px; */
}

.position {
  position: absolute;
  /* height: 570px; */
  width: 100%;
  z-index: 9999;
  top: 0;
}

.logoPic {
  position: absolute;
}

.char {
  /* flex: 1; */
  /* width: 600px; */
  display: flex;
}

.echartsLine {
  /* width: 600px; */
  flex: 1;
  /* height: calc(100%); */
}

.oneCard .cont {
  /* margin-top: 0 !important; */
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cont {
  /* margin-left: 27px; */
  /* margin-top: 20px; */
  /* flex: 1 */
  width: calc((100% - 30px) / 2);
}

.cardTitle {
  /* width: 377px; */
  height: 32px;
  font-size: 27px;
  font-family: Arial-BoldMT-, Arial-BoldMT;
  font-weight: normal;
  color: #168ec7;
  line-height: 32px;
  text-align: center;
}

.cardDesc {
  width: 336px;
  font-size: 11px;
  font-family: ArialMT-, ArialMT;
  font-weight: normal;
  color: #222222;
  line-height: 18px;
  text-align: left;
  margin-top: 13px;
}

.cardButton {
  width: 127px;
  height: 35px;
  border-radius: 35px;
  opacity: 1;
  border: 1px solid #168ec7;
  color: #168ec7;
  line-height: 37px;
  font-size: 11px;
  margin-top: 70px;
  cursor: pointer;
}

.cardButton2 {
  width: 127px;
  height: 35px;
  border-radius: 35px;
  opacity: 1;
  border: 1px solid #168ec7;
  color: #168ec7;
  line-height: 37px;
  font-size: 11px;
  cursor: pointer;
  position: absolute;
}

.twoCard {
  /* min-width: 725px; */
  width: 1050px;
  /* height: 497px; */
  padding-bottom: 20px;
  /* background: rgba(246, 246, 246, 0.7); */
  background: rgba(204, 204, 204, 0.3);
  box-shadow: 0px 4px 11px 0px rgba(0, 0, 0, 0.10000000149011612);
  border-radius: 11px 11px 11px 11px;
  opacity: 1;
  margin-top: 28px;
  /* display: flex; */
  position: relative;
  /* z-index: 99; */
}

.rightBg {
  /* background: url(@/assets/slices_slices/pcbg.png) no-repeat center center; */
  background-size: 100% 100%;
  width: calc((100% - 30px) / 2);
  /* width: 42%; */
  /* width: 400px; */
  /* flex:1!important; */
  /* height: 367px; */
  margin: auto;
  /* margin-right: 60px; */
  position: relative;
  flex: 1;
}

.twoCard .cont {
  /* flex: 1 !important; */
  /* width: 400px; */
  /* margin-right: 5%; */
  /* width: calc(100%-367px); */
}

.threeCard {
  /* min-width: 725px; */
  width: 1050px;
  /* height: 336px; */
  background: rgba(204, 204, 204, 0.3);
  /* background: rgba(246, 246, 246, 0.7); */
  box-shadow: 0px 4px 11px 0px rgba(0, 0, 0, 0.10000000149011612);
  border-radius: 11px 11px 11px 11px;
  opacity: 1;
  display: flex;
  margin-top: 28px;
  position: relative;
  z-index: 99;
  flex-direction: column;
}
.threeCard .top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
}
.fourCard {
  /* min-width: 725px; */
  width: 1050px;
  /* height: 364px; */
  background: rgba(204, 204, 204, 0.3);
  /* background-color: #cccccc; */
  box-shadow: 0px 4px 11px 0px rgba(0, 0, 0, 0.10000000149011612);
  border-radius: 11px 11px 11px 11px;
  opacity: 1;
  margin-top: 28px;
  margin-bottom: 35px;
  position: relative;
  z-index: 99;
}

.text_list {
  margin-top: 42px;
  width: 100%;
}

.text_list span {
  width: 2px;
  height: 2px;
  border-radius: 50%;
  opacity: 1;
  border: 2px solid #e8724e;
  position: absolute;
  left: 15px;
  /* top: 10px; */
  /* display: ; */
}

.fourCard .bottom .title {
  display: inline-block;
}

.ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  /* margin: 0 18px; */
}

.ul .li {
  display: flex;
  align-items: center;
  font-size: 13px;
  height: 32px;
  align-items: center;
  border-bottom: 1px solid #f4f4f4;
  cursor: pointer;
  /* margin-left: 35px; */
  /* min-width: calc((100% - 140px) / 3); */
  width: 46%;
  justify-content: space-between;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.bottomLiLeft {
  /* width: 300px; */
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}
/* .ul .li .time{
		flex: 1;
	} */
.titleUl {
  width: 386px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}

.ul .li .time {
  transform: scale(0.8);
  color: #999999;
  margin-left: 17px;
  width: 130px;
  text-align: right;
}

.ul .li span {
  width: 2px;
  height: 2px;
  border-radius: 50%;
  opacity: 1;
  border: 2px solid #e8724e;
  display: block;
  margin: 0 !important;
  margin-right: 10px !important;
}

.text_list .li {
  width: 100%;
  position: relative;
}

.fqTitle.is-active {
  background: rgba(240, 240, 240, 0.65);
  border-radius: 15px 15px 15px 15px;
  padding: 0 14px;
  /* width:var(--b) */
}

.li span {
  /* margin-top: 20px; */
}

.Progress {
  flex: 1;
  /* margin-left: 34px; */
  /* margin-top: 20px; */
}

.threeCard .cont {
  /* margin-left: 4.5%; */
  /* margin-right: 3.3%; */
}

.lineLi {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.lineLi .left_li {
  flex: 1;
  margin-right: 90px;
}

.lineLi .lvse,
.lineLi .lanse,
.lineLi .zise,
.lineLi .shenzi,
.lineLi .caolv,
.lineLi .chengse {
  /* flex: 1; */
  width: 70%;
  margin-right: 1.5%;
}

.lineLi .lanse1,
.lineLi .lanse2,
.lineLi .lanse3,
.lineLi .lanse4,
.lineLi .lanse5,
.lineLi .lanse6 {
  flex: 1;
  margin-right: 1.5%;
}

.lineName {
  text-align: left;
  color: #474747;
  font-size: 14px;
  margin-bottom: 5px;
  font-weight: 500;
  cursor: pointer;
  width: 100%;
}

.right_li .number {
  color: #474747;
  font-size: 14px;
  text-align: right;
  font-weight: 700;
}

.right_li .type {
  color: #474747;
  font-size: 10px;
  text-align: right;
}

.fourCard .top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
}

.searchMessage {
  height: 27px;
  width: 27px;
  color: #2468f2;
  margin-left: 12px;
  line-height: 27px;
}

.twoCard .searchMessage {
  position: absolute;
  right: 27px;
  top: 20px;
}

.line {
  width: 130%;
  height: 2px;
  background: #168ec7;
  position: absolute;
  bottom: -20px;
  left: -15%;
  display: block;
  opacity: 0;
}

.nav p {
  position: relative;
}

.nav p.isActive {
  color: #168ec7;
}

.nav p.isActive .line {
  opacity: 1;
}

.MenuIcon {
  display: none;
  position: absolute;
  top: 25px;
  right: 120px;
}
</style>

<style>
.overHide {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.el-collapse-item__header {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.el-collapse-item__arrow {
  display: none;
}

.li .el-collapse-item__header {
  margin-left: 30px;
  padding-bottom: 20px;
}

.el-collapse {
  border: none;
}

.el-collapse-item__header {
  border-bottom: 1px solid #f4f4f4;
}

.el-collapse-item:last-child {
  margin-bottom: 0;
  width: calc(100%-50px);
}

.el-collapse-item__content {
  text-align: left;
  padding-bottom: 15px !important;
}

.el-collapse-item__wrap {
  border-bottom: none;
  background: none;
}

.el-collapse-item__header {
  background: none;
  height: 40px !important;
}

.el-collapse-item__header.is-active {
  margin: 0;
  font-size: 14px;
  padding: 0;
}

.el-progress-bar__outer,
.el-progress-bar__inner {
  border-radius: 0;
}

.el-progress-bar__outer {
  height: 10px !important;
}

.zise .el-progress-bar__inner {
  /* background: #1da563; */
  background: rgba(22, 142, 199, 0.7);
}

.lvse .el-progress-bar__inner {
  /* background: #116bb1; */
  background: rgba(22, 142, 199, 0.3);
}

.shenzi .el-progress-bar__inner {
  /* background: #15a8aa; */
  background: rgba(22, 142, 199, 0.5);
}

.chengse .el-progress-bar__inner {
  background: #f0a929;
}

.caolv .el-progress-bar__inner {
  background: #ea4f17;
}

.lanse .el-progress-bar__inner {
  /* background: rgb(10, 113, 213); */
  background: rgba(22, 142, 199, 0.1);
}

.lanse6 .el-progress-bar__inner {
  background: rgba(22, 142, 199, 1);
}

.lanse1 .el-progress-bar__inner {
  background: rgba(22, 142, 199, 0.1);
}

.lanse2 .el-progress-bar__inner {
  background: rgba(22, 142, 199, 0.3);
}

.lanse3 .el-progress-bar__inner {
  background: rgba(22, 142, 199, 0.5);
}

.lanse4 .el-progress-bar__inner {
  background: rgba(22, 142, 199, 0.7);
}

.lanse5 .el-progress-bar__inner {
  background: rgba(22, 142, 199, 0.9);
}

.searchMessage.el-button {
  border: 1px solid #2468f2;
}

.el-carousel__indicators--horizontal {
  opacity: 0 !important;
}

.el-popover {
  min-width: 100px !important;
  z-index: 999999 !important;
}

.el-collapse-item__header.is-active {
  /* white-space: nowrap; */
}
</style>
